module.exports = __webpack_public_path__ + "img/ColorLensOutlined.31344f7e.svg";